// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._20oM2rDpiP2xgB {\n  float: left;\n  display: inline-flex;\n  padding: 8px 4px 8px 6px;\n  align-self: center;\n}\n._1vMLLGpv0Km3dg {\n  margin-left: -2px;\n  float: right;\n  position: relative;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"membersCell": "_20oM2rDpiP2xgB",
	"avatar": "_1vMLLGpv0Km3dg"
};
export default ___CSS_LOADER_EXPORT___;
